// Strong-RTL Unicode ranges: Hebrew + Arabic + Syriac/supplements (0590–08FF),
// Hebrew/Arabic presentation forms (FB1D–FDFF, FE70–FEFE — FEFE not FEFF so a
// stray BOM/ZWNBSP doesn't trip detection). A single precompiled regex keeps the
// per-chunk test allocation-free; we only need "is any strong-RTL char present".
const RTL_RE = /[֐-ࣿיִ-﷿ﹰ-﻾]/;

export function containsRtl(text: string): boolean {
  return typeof text === "string" && RTL_RE.test(text);
}
